import type { RequestConfig } from '@customTypes/index';
import type { WorkRequestItemDto } from '@customTypes/types';

import { api } from '@/shared/api/instance';

export type AcceptWorkRequest = {
  workRequestId: string;
};

export type AcceptWorkRequestParams = RequestConfig<AcceptWorkRequest>;

export const acceptWorkRequest = async ({
  params,
  config
}: AcceptWorkRequestParams) =>
  api.post<WorkRequestItemDto>(
    `/api/work/requests/${params.workRequestId}/accept`,
    config
  );
